import { get, writable } from 'svelte/store';
import { isNonProductionAppBuild } from 'src/helpers/dev_tools';
import {
	isRelayOverlayForce,
	type RelayCloseChrome,
	type RelayPriorityDevForce,
} from 'src/helpers/relay_priority_layout';
import { claimPriorityLayoutDevHud } from 'src/stores/features/dev/priority-layout-dev-hud-state';

const FORCE_KEY = 'shelly_dev_relay_priority_force';
const CHROME_KEY = 'shelly_dev_relay_priority_close_chrome';

const readForce = (): RelayPriorityDevForce => {
	if (!isNonProductionAppBuild()) return 'auto';
	try {
		const stored = localStorage.getItem(FORCE_KEY);
		if (
			stored === 'auto' ||
			stored === 'on' ||
			stored === 'off' ||
			stored === 'timer' ||
			isRelayOverlayForce(stored as RelayPriorityDevForce)
		) {
			return stored as RelayPriorityDevForce;
		}
	} catch {
		// localStorage may be unavailable
	}
	return 'auto';
};

const readChrome = (): RelayCloseChrome => {
	if (!isNonProductionAppBuild()) return 'label';
	try {
		const stored = localStorage.getItem(CHROME_KEY);
		if (stored === 'label' || stored === 'icon') return stored;
	} catch {
		// localStorage may be unavailable
	}
	return 'label';
};

export const relayPriorityDevForce = writable<RelayPriorityDevForce>(readForce());
export const relayPriorityCloseChrome = writable<RelayCloseChrome>(readChrome());

relayPriorityDevForce.subscribe((value) => {
	if (!isNonProductionAppBuild()) return;
	try {
		localStorage.setItem(FORCE_KEY, value);
	} catch {
		// localStorage may be unavailable
	}
});

relayPriorityCloseChrome.subscribe((value) => {
	if (!isNonProductionAppBuild()) return;
	try {
		localStorage.setItem(CHROME_KEY, value);
	} catch {
		// localStorage may be unavailable
	}
});

export const claimRelayPriorityDevHud = (): (() => void) => claimPriorityLayoutDevHud('relay');

export const getRelayPriorityDevForce = (): RelayPriorityDevForce =>
	isNonProductionAppBuild() ? get(relayPriorityDevForce) : 'auto';

export const setRelayPriorityDevForce = (force: RelayPriorityDevForce) => {
	relayPriorityDevForce.set(isNonProductionAppBuild() ? force : 'auto');
};

export const setRelayPriorityCloseChrome = (chrome: RelayCloseChrome) => {
	relayPriorityCloseChrome.set(isNonProductionAppBuild() ? chrome : 'label');
};
